import {AdditionalGroupProps} from 'modules/additional-groups/types';
import additionalGroupsKeys from 'modules/additional-groups/util/additional-groups-keys';
import React from 'react';
import {IoDuplicate, IoTrash} from 'react-icons/io5';
import List from 'shared/layout/list';
import ApiDynamicButton from 'shared/migration-components/api-dynamic-button';
import useProjection from 'shared/migration-hooks/use-projection';

const AdditionalGroups: React.FC = () => {
  const projection = useProjection<AdditionalGroupProps>(
    'additionalGroups',
    ['companyName', 'description', 'name'],
    {orderBy: {field: 'name', order: 1}},
  );

  return (
    <List<AdditionalGroupProps>
      {...{
        titleBar: {
          title: 'Grupo de adicionais',
          actionButton: {title: 'NOVO GRUPO DE ADICIONAL', to: 'create'},
        },
        table: {
          url: '/additional-groups',
          projection: {
            ...projection,
            options: [
              'description',
              'name',
              'companyName',
              {
                value: 'id',
                label: 'Ações',
                column: (row) => (
                  <div style={{display: 'flex', gap: 5}}>
                    <ApiDynamicButton
                      request={{
                        url: `/additional-groups/${row.id}/duplicate`,
                        errorTitle: 'Erro ao duplicar grupo de adicionais',
                        field: row.id,
                        method: 'POST',
                      }}
                      button={{
                        icon: <IoDuplicate />,
                        tooltip: 'Duplicar grupo de adicionais',
                      }}
                      keys={{createInfiniteList: additionalGroupsKeys.list()}}
                    />
                    <ApiDynamicButton
                      request={{
                        url: `/additional-groups/${row.id}`,
                        errorTitle: 'Erro ao remover grupo de adicionais',
                        field: row.id,
                        method: 'DELETE',
                      }}
                      button={{
                        icon: <IoTrash />,
                        tooltip: 'Remover',
                      }}
                      confirmButtonText="grupo de adicionais"
                      keys={{deleteInfiniteList: additionalGroupsKeys.list()}}
                    />
                  </div>
                ),
              },
            ],
          },
          translatedPropsKey: 'AdditionalGroupProps',
        },
        queryKey: additionalGroupsKeys.list(),
      }}
    />
  );
};

export default AdditionalGroups;
